import React, { useEffect, useState } from "react";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Constants } from "../lib/const/constants";
import { CURRENCIES } from "../lib/currencies";
import { FaSearch } from "react-icons/fa";
import { ArrowRight } from 'lucide-react'
import axios from "axios";

function Pay() {
  const navigate = useNavigate();
  const [balances, setBalances] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [sortcode, setSortcode] = useState("");
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [usedBalances, setUsedBalances] = useState([]);
  const [selectedValues, setSelectedValues] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [clearBankBalance, setclearBankBalance] = useState(0.00);
  const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.00);
  const [clearBankConfiguration, setclearBankConfiguration] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [isDataLoading, setIsDataLoading] = useState(true);
  console.log("selected values", selectedValues);
  console.log(clearBankBalance);
  console.log(currencyCloudBalance);
  console.log(clearBankConfiguration);

  useEffect(() => {
    getData();
    getBalances();
  }, []);

  const getData = async () => {
    const workspace = sessionStorage.getItem("login_workspaces");
    if (workspace) {
      const parsedWorkspace = JSON.parse(workspace);
      setAccountNumber(parsedWorkspace[0]?.accounts?.meta?.account_number || "");
      setSortcode(parsedWorkspace[0]?.accounts?.meta?.routing_code || "");
    }
  };

  const getBalances = async () => {
    if (balanceLoading) return;
    setBalanceLoading(true);
    setIsDataLoading(true);
    const login_workspaces_id = sessionStorage.getItem("login_workspaces_id");
    const login_token = sessionStorage.getItem('login_token');
    if (!login_workspaces_id) {
      setBalanceLoading(false);
      setIsDataLoading(false);
      return;
    }
    try {
      const resp = await axios.get(
        `${Constants.BASE_URL}API-FX-231-GET-WALLET-BALANCES/${login_workspaces_id}`,
        {
          headers: {
            Authorization: 'Bearer' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY
          }
        }
      );
      const balArray = Object.values(resp.data);
      setUsedBalances(resp.data.used_balances);
      balArray.pop();
      setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
      setclearBankBalance(resp.data.clear_bank_account_balance);
      setclearBankConfiguration(resp.data.fees_configuration);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) {
        setBalances(balArray);
      } else {
        const defaultBank = sessionStorage.getItem('defaultBank');
        const parsedWorkspace = JSON.parse(sessionStorage.getItem('login_workspaces'));
        var ref = "";
        if (defaultBank === 'Clear Bank as Service') {
          console.log("cb");
        } else {
          if (Object.keys((parsedWorkspace[0].accounts)).length > 0) {
            console.log("cc");
          } else {
            ref = (JSON.parse(sessionStorage.getItem('login_workspaces'))[0].memberships.urn);
          }
        }
        if (ref != "") {
          setBalances(Constants.INDIVIDUAL_BALANCES_CURRENCIES);
        }
      }
    } catch (err) {
      console.error(err.response?.data);
    } finally {
      setBalanceLoading(false);
      setIsDataLoading(false);
    }
  };

  const setSelectedValue = (val) => {
    console.log(val);
    setSelectedValues(val);
    setIsOpen(false);
  };

  const navigateToScreen = () => {
    if (selectedValues) {
      navigate("/SendMoney", { state: selectedValues });
    }
  };

  const filteredBalances = balances.filter(({ currency }) => {
    const code = (currency || '').toString();
    const name = (CURRENCIES[code] || '');
    const q = searchTerm.trim().toLowerCase();
    if (!q) return true;
    return code.toLowerCase().includes(q) || name.toLowerCase().includes(q);
  });

  const LockBadge = () => (
    <div style={styles.lockBadge}>
      <img
        src="/lockImg.png"
        alt="lock"
        style={{ width: '30px', height: '30px', }}
      />
    </div>
  );

  return (
    <div style={styles.page} onClick={() => {
      if (isOpen) {
        setIsOpen(false)
      }
    }}>

      <div style={styles.topContent}>

        <h2 style={styles.title}>Select Currency</h2>

        <div style={styles.outerCard}>
          <div style={styles.innerSelectBox} onClick={() => setIsOpen(!isOpen)}>
            {selectedValues ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
                <img src={selectedValues.flag} alt="" style={styles.flag} />
                <span style={styles.currCode}>{selectedValues.currency}</span>
                <span style={styles.currName}>
                  {' '}
                  - {CURRENCIES[selectedValues.currency]}
                </span>
              </div>
            ) : (
              <span style={styles.placeholder}>Select Currency</span>
            )}
            <svg
              width="16" height="9" viewBox="0 0 16 9" fill="none"
              style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
                flexShrink: 0,
              }}
            >
              <path d="M1 1L8 8L15 1" stroke="#999999" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {isOpen && (
            <div style={styles.dropdown}>
              {isDataLoading ? (
                <div style={styles.dropMsg}>Loading...</div>
              ) : (
                <>
                  <div style={styles.searchRow}>
                    <FaSearch style={{ color: '#bbb', fontSize: 12, flexShrink: 0 }} />
                    <input
                      type="text"
                      placeholder="Search currency..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      style={styles.searchInput}
                    />
                  </div>
                  {filteredBalances.length > 0 ? (
                    filteredBalances.map((resp, index) => {
                      const flagUrl = (() => {
                        switch (resp.currency) {
                          case 'EUR':
                            return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
                          case 'RON':
                            return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
                          case 'DKK':
                            return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
                          case 'NOK':
                            return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
                          case 'SEK':
                            return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
                          case 'MYR':
                            return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
                          default:
                            return `${Constants.FXMASTER_BASE_URL}flags/${resp?.meta?.flag?.split('/').pop()}`;
                        }
                      })();
                      const data = {
                        currency: resp?.currency,
                        balance:
                          resp.currency && usedBalances[resp?.currency]
                            ? parseFloat(
                                resp?.balance - usedBalances[resp?.currency] < 0
                                  ? '0'
                                  : resp?.balance -
                                      usedBalances[resp?.currency],
                              ).toFixed(2)
                            : parseFloat(resp?.balance).toFixed(2),
                        flag: flagUrl,
                        currencyid: resp?.meta?.country_id,
                        accountNumber,
                        sortcode,
                      };
                      const isSel = selectedValues?.currency === resp.currency;
                      return (
                        <div
                          key={index}
                          style={{
                            ...styles.dropItem,
                            background: isSel ? '#FFF4EC' : 'transparent',
                          }}
                          onMouseEnter={(e) => {
                            if (!isSel)
                              e.currentTarget.style.background = '#fafafa';
                          }}
                          onMouseLeave={(e) => {
                            if (!isSel)
                              e.currentTarget.style.background = 'transparent';
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedValue(data);
                          }}
                        >
                          <img src={flagUrl} alt="" style={styles.flag} />
                          <span style={styles.currCode}>{resp.currency}</span>
                          <span style={styles.currName}>
                            - {CURRENCIES[resp.currency]}
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <div style={styles.dropMsg}>No results found</div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {!selectedValues && (
          <>
            <div style={styles.secureBanner}>
              <LockBadge />
              <div style={styles.secureBannerText}>
                <div style={styles.secureTitle}>100% Secure & Safe</div>
                <div style={styles.secureSub}>
                  Your money is protected with bank-level encryption. We never store your banking credentials.
                </div>
              </div>
            </div>

            <button disabled style={styles.btnDisabled}>
              <span>Proceed</span>
              <ArrowRight className="w-5 h-5 ml-1" />
            </button>
          </>
        )}

        {selectedValues && (
          <>
            <button
              onClick={navigateToScreen}
              style={styles.btnActive}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.9'; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
            >
             <span>Proceed</span>
             <ArrowRight className='w-5 h-5 -ml-2.5'/>
            </button>
            <div style={styles.secureBanner}>
              <LockBadge />
              <div style={styles.secureBannerText}>
                <div style={styles.secureTitle}>100% Secure & Safe</div>
                <div style={styles.secureSub}>
                  Your money is protected with bank-level encryption. We never store your banking credentials.
                </div>
              </div>
            </div>
          </>
        )}

      </div>

      {!selectedValues && (
        <div style={styles.metricsRow}>
          <div style={styles.metricItem}>
            <img src="/clock.png" alt="rocket" style={styles.metricIcon} />
            <div style={styles.metricTextGroup}>
              <div style={styles.metricTitle}>Fast Delivery</div>
              <div style={styles.metricSub}>Funds typically delivered in 1 hour</div>
            </div>
          </div>
          <div style={styles.metricItem}>
            <img src="/lock.png" alt="rocket" style={styles.metricIcon} />
            <div style={styles.metricTextGroup}>
              <div style={styles.metricTitle}>Secure Transfer</div>
              <div style={styles.metricSub}>Bank-level security &amp; encryption</div>
            </div>
          </div>
          <div style={styles.metricItem}>
            <img src="/rates.png" alt="rocket" style={styles.metricIcon} />
            <div style={styles.metricTextGroup}>
              <div style={styles.metricTitle}>Great Rates</div>
              <div style={styles.metricSub}>Better Rates, Low Fees</div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

const styles = {

  page: {
    minHeight: '100vh',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',

    padding: '0 20px',

    backgroundColor: '#ffffff',
    backgroundImage: 'linear-gradient(to bottom, #f8fafc 0%, #eff6ff4d 50%, #eef2ff66 100%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    cursor: 'pointer',
  },

  topContent: {
    flex: 1,
    width: '100%',
    maxWidth: 720,
    alignSelf: 'center',
    paddingTop: '36px',
    paddingBottom: '20px',
  },

  title: {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: '700',
    color: '#0B214E',
    marginBottom: 20,
    marginTop: 0,
  },

  outerCard: {
    width: 640,
    height: 138,
    background: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #F3F2F2',
    boxShadow: '0px 4px 16px -4px rgba(0, 0, 0, 0.06)',
    padding: 24,
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    position: 'relative',
    overflow: 'visible',
  },

  innerSelectBox: {
    width: '592px',
    background: '#FFFFFF',
    borderRadius: '12px',
    borderWidth: '1px',
    border: '1px solid #E2E6ED',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: 16,
    paddingRight: 16,
    cursor: 'pointer',
    userSelect: 'none',
    opacity: 1,

  },

  placeholder: {
    fontSize: '0.92rem',
    color: '#a9a9a9',
    flex: 1,
  },

  flag: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    objectFit: 'cover',
    flexShrink: 0,
  },

  currCode: {
    fontSize: '0.92rem',
    fontWeight: 700,
    color: '#1A1A1A',
  },

  currName: {
    fontSize: '0.92rem',
    color: '#555555',
    fontWeight: 400,
  },

  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 24,
    right: 24,
    marginTop: 8,
    borderRadius: 10,
    border: '1px solid #EFEFEF',
    background: '#FFFFFF',
    maxHeight: 260,
    overflowY: 'auto',
    zIndex: 999,
    boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
  },

  searchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 14px',
    borderBottom: '1px solid #F0F0F0',
    position: 'sticky',
    top: 0,
    background: '#FFFFFF',
    zIndex: 1,
  },

  searchInput: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: '0.85rem',
    color: '#222',
    width: '100%',
  },

  dropItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 14px',
    cursor: 'pointer',
    transition: 'background 0.1s',
  },

  dropMsg: {
    padding: '14px',
    textAlign: 'center',
    fontSize: '0.82rem',
    color: '#BBBBBB',
  },

  secureBanner: {
    marginTop: '14px',
    background: '#F6F0EC',
    borderRadius: '14px',
    border: '1px solid #EFDCD0',
    padding: '16px 20px',
    display: 'flex',
    gap: 16,
    width: 640,
    margin: '14px auto 0',
    alignItems: 'flex-start',
  },

  secureBannerText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },

  secureTitle: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#203358',
    lineHeight: 1.5,
  },

  secureSub: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#676F7D',
    lineHeight: 1.4,
    marginTop: 4,
  },

  btnActive: {
    width: '640px',
    height: '56px',
    borderRadius: '12px',
    gap: '16px',
    padding: '12px 20px',
    background: '#D26521',
    boxShadow: '0px 8px 20px 0px #0000001F',
    opacity: 1,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '1rem',
    letterSpacing: '0.02em',
    transition: 'opacity 0.15s',
    margin: '14px auto 0',
    color: '#FFFFFF',
  },

  btnDisabled: {
    width: 640,
    height: 56,
    borderRadius: 12,
    background: '#CCCCCC',
    color: '#FFFFFF',
    border: 'none',
    cursor: 'not-allowed',
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: '0.02em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 20px',
    boxShadow: '0px 8px 20px 0px rgba(0, 0, 0, 0.12)',
    margin: '14px auto 0',
  },

  metricsRow: {
    width: '100%',
    maxWidth: 720,
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: '32px',
    paddingTop: '0px',
  },

  metricItem: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
    padding: '8px 12px',
  },

  metricIcon: {
    lineHeight: 1,
    flexShrink: 0,
    height: '18px',
    width: '22px',
  },

  metricTextGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },

  metricTitle: {
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '150%',
    letterSpacing: '0%',
    color: '#203358',
  },

  metricSub: {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '150%',
    letterSpacing: '0%',
    color: '#676F7D',
  },
};

export default Pay;